import { useMediaQuery, Zoom } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid2'
import Link from '@mui/material/Link'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { BASE_API_URL } from '../../../../api/endpoints.constants'
import { BlockWrapper } from '../../../../components/Wrapper/BlockWrapper'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { theme } from '../../../../theme'
import { SidebarType } from '../../../../types/sidebars'
import CitationSideBar from '../../../InternalPage/RequestMessagesPage/components/CitationSideBar'

export const ExternalWrapper = ({ children }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    const { openSidebarType } = useWrapperStore((state) => state)

    const showCitationSidebar = openSidebarType === SidebarType.CITATIONS

    return (
        <Box sx={{ display: 'flex', height: '10vh' }}>
            <Box
                component="main"
                sx={{ flexGrow: 1, height: '100%', p: '8px 16px 8px 24px', maxWidth: '100vw' }}>
                <Grid container spacing={4} sx={{ width: '100%', m: 0 }}>
                    <Grid
                        size={{ xs: 12, sm: 12, md: 8 }}
                        sx={{
                            p: isMobile ? '12px' : '24px 24px 12px',
                            background: '#fff',
                            borderRadius: '28px',
                            display: 'flex',
                            flexFlow: 'column',
                        }}>
                        {children}
                    </Grid>

                    <Grid
                        size={{ xs: 12, sm: 12, md: 4 }}
                        sx={{
                            position: isMobile ? 'static' : 'fixed',
                            right: '12px',
                            top: '0',
                            p: isMobile ? '0' : '8px 16px 24px 16px',
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column',
                            height: '100%',
                        }}>
                        {showCitationSidebar ? (
                            <Zoom in={true}>
                                <Grid sx={{ width: '100%' }}>
                                    <BlockWrapper>
                                        <CitationSideBar />
                                    </BlockWrapper>
                                </Grid>
                            </Zoom>
                        ) : null}

                        {!showCitationSidebar ? (
                            <Paper
                                sx={{
                                    width: '100%',
                                    padding: 2,
                                    margin: 0,
                                    borderRadius: '28px',
                                    border: 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>
                                <Box>
                                    <Grid
                                        sx={{
                                            textAlign: 'center',
                                            verticalAlign: 'center',
                                        }}>
                                        <a href="/" style={{ maxWidth: '200px' }}>
                                            <img src="/logo.svg" />
                                        </a>
                                        <Typography
                                            variant="h6"
                                            sx={{ paddingRight: '4px', mt: 4 }}>
                                            Этот материал сгенерирован с помощью искусственного
                                            интеллекта в экосистеме Arhiassistant. Попробуйте весь
                                            функционал продукта!
                                        </Typography>

                                        <Button
                                            id="RefferalTryForFree"
                                            href={`${BASE_API_URL}/api/v1/auth/demo?checkword=J2bucFynEgnS`}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            sx={{
                                                position: 'flex',
                                                marginLeft: 'auto',
                                                my: '16px',
                                            }}>
                                            Попробовать бесплатно
                                        </Button>
                                        <Typography
                                            variant="h6"
                                            sx={{ paddingRight: '4px', mb: 1 }}>
                                            Так же вы можете
                                        </Typography>

                                        <Link
                                            href="/login"
                                            variant="h6"
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-around',
                                            }}>
                                            Зарегистрироваться
                                        </Link>
                                        <Link
                                            href="/login"
                                            variant="h6"
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-around',
                                            }}>
                                            Войти
                                        </Link>
                                    </Grid>
                                </Box>
                            </Paper>
                        ) : null}
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}
